
export interface DawaPostalData {
    "href": string,
    "nr": string,
    "navn": string,
    "kommuner": {
        "href": string,
        "kode": string,
        "navn": string
    }[]
}

export type DawaAutocompletePostalData = {
    "tekst": string,
    "postnummer": {
        "nr": string,
        "navn": string,
        "stormodtager": boolean,
        "visueltcenter_x": number,
        "visueltcenter_y": number,
        "href": string,
    }
}[];

export type AutocompletePostalData = {
    title: string,
    value: string,
    tooltip: string,
}[];

export interface PostalMunicipality {
    link: string,
    id: string,
    name: string,
}

export interface PostalData {
    id: string,
    name: string,
    municipalities: PostalMunicipality[],
}

export const postalDataFromDawa = (pd: DawaPostalData): PostalData => {

    const municipalities = pd.kommuner.map((kommune) => {
        return {
            link: kommune.href,
            id: kommune.kode,
            name: kommune.navn,
        }
    })

    return {
        id: pd.nr,
        name: pd.navn,
        municipalities: municipalities,
    }
}

export default PostalData;